import { render, staticRenderFns } from "./bulma_bottombar.vue?vue&type=template&id=161c6b83&scoped=true&lang=html"
import script from "./bulma_bottombar.vue?vue&type=script&lang=js"
export * from "./bulma_bottombar.vue?vue&type=script&lang=js"
import style0 from "./bulma_bottombar.vue?vue&type=style&index=0&id=161c6b83&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161c6b83",
  null
  
)

export default component.exports